import { Box, Text } from "@vinomofo/components";
import styled, { keyframes } from "styled-components";
import { useCallback } from "react";
import { scrollToElementBySelector } from "../../utils/smooth-scroll-to";
import glassesImage from "../../images/whisky-glasses.png";

const shake = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(7px);
  }
  100% {
    transform: translateX(0);
  }
`;

const NextArrow = styled.span`
  width: 55px;
  height: 2px;
  background-color: #000000;
  position: relative;
  display: inline-block;
  margin-left: 8px;
  transition: all 0.3s ease;

  &::before,
  &::after {
    content: "";
    display: block;
    width: 12px;
    height: 2px;
    border-radius: 4px;
    background-color: #000000;
    position: absolute;
    right: 0;
    transition: all 0.3s ease;
  }

  &::before {
    transform: rotate(-42deg);
    transform-origin: top right;
  }

  &::after {
    transform: rotate(42deg);
    transform-origin: 12px 1px;
  }
`;

const CTAButton = styled(Box)`
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  padding: 16px 24px;
  margin: 5px 0 20px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  min-width: 380px;
  max-width: 420px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
    ${NextArrow} {
      animation: ${shake} 1s infinite;
    }
  }
`;

const CTAContent = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const CTAText = styled(Text)`
  font-weight: 700;
  font-size: 18px;
  color: #000;
  line-height: 1.3;
  text-align: left;
`;

const CTATextLine = styled(Text)`
  font-weight: 700;
  font-size: 16px;
  color: #010102;
  line-height: 1.7;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const GlassesImage = styled.img`
  margin-right: 16px;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
`;

const UnlockAccessCTA = () => {
  const handleCTAClick = useCallback(() => {
    scrollToElementBySelector(".hs-button", {
      highlightDuration: 300,
      scale: 1.05,
      glowColor: "rgba(251, 196, 78, 0.5)",
    });
  }, []);

  return (
    <CTAButton onClick={handleCTAClick}>
      <GlassesImage src={glassesImage} alt="Glasses" width={80} height={80} />
      <CTAContent>
        <CTAText>ALRIGHT, ENOUGH SCROLLING.</CTAText>
        <CTATextLine>
          UNLOCK ACCESS TODAY <NextArrow />
        </CTATextLine>
      </CTAContent>
    </CTAButton>
  );
};

export default UnlockAccessCTA;
